import { JSX, ComponentType, LazyExoticComponent } from 'react';

import { HtmlPlayer } from '../Players/HtmlPlayer';
import { IframePlayer } from '../Players/IframePlayer';
import { VideoElementProps, VideoProps } from '../types';
import { VideoFailed } from '../VideoFailed';

import { canPlay } from './canPlay';

export type PlayerEntry = {
  key: string;
  name: string;
  canPlay: (src: string) => boolean;
  canEnablePIP?: () => boolean;
  player?:
    | ComponentType<VideoElementProps>
    | LazyExoticComponent<ComponentType<VideoElementProps>>
    | LazyExoticComponent<
        ({ src, description, editable }: VideoProps) => JSX.Element
      >;
};

export const Players = (allowDirectVideoLinks?: boolean) => {
  const playersList: PlayerEntry[] = [
    {
      key: 'failed',
      name: 'failed',
      canPlay: () => false,
      player: VideoFailed,
    },
    {
      key: 'rutube',
      name: 'Rutube',
      canPlay: canPlay.rutube,
      player: IframePlayer,
    },
    {
      key: 'vkvideo',
      name: 'VkVideo',
      canPlay: canPlay.vkvideo,
      player: IframePlayer,
    },
  ];

  if (allowDirectVideoLinks) {
    playersList.push({
      key: 'html',
      name: 'html',
      canPlay: canPlay.html,
      canEnablePIP: () => {
        const userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.indexOf('firefox') > -1) {
          return false;
        }

        return true;
      },
      player: HtmlPlayer,
    });
  }

  return playersList;
};
